import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5071673e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = { class: "headerTitleContainer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Clock-In Details  ", -1))
const _hoisted_6 = { class: "headerActions" }
const _hoisted_7 = { "aria-hidden": "true" }
const _hoisted_8 = { class: "neu-tooltip--text tooltipTxt" }
const _hoisted_9 = { "aria-hidden": "true" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_11 = { class: "panleBody" }
const _hoisted_12 = {
  id: "divClockInStatusDetails",
  style: {"height":"100%"}
}
const _hoisted_13 = { class: "header-clockPop txtLeft" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { id: "hrClockInStatusLine" }, null, -1))
const _hoisted_15 = { id: "spnDeptFacilityName" }
const _hoisted_16 = { id: "spnClockInStatusSecondHeader" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"20px"} }, null, -1))
const _hoisted_18 = {
  class: "col-emsu-width-12",
  style: {"height":"85%"}
}
const _hoisted_19 = {
  id: "clockIn-content-loading",
  class: "text-center mt-3",
  style: {"text-align":"center"}
}
const _hoisted_20 = { class: "fa-2x" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1))
const _hoisted_22 = {
  key: 0,
  id: "gridClockInDetails",
  class: "scrollBar"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 1,
  id: "home-message",
  class: "text-center mt-3"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { id: "home-message-text" }, "No results found", -1))
const _hoisted_26 = [
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_table_heading = _resolveComponent("neu-table-heading")!
  const _component_neu_table_row = _resolveComponent("neu-table-row")!
  const _component_neu_label = _resolveComponent("neu-label")!
  const _component_neu_table_body = _resolveComponent("neu-table-body")!
  const _component_neu_table = _resolveComponent("neu-table")!
  const _component_neu_card = _resolveComponent("neu-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            (_ctx.isShowTrainingLink && _ctx.profileData.TrainingEnabled)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "modaltoolbarIcon neu-tooltip",
                  style: {"cursor":"pointer","color":"#3673AA"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fnOpenVideo && _ctx.fnOpenVideo(...args)))
                }, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'fa-video'],
                      size: "lg"
                    }),
                    _createTextVNode(" Learn How ")
                  ]),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.trainingLinkToolTip), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.facilityName), 1),
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.lastUpdateDate), 1)
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_font_awesome_icon, {
                  spin: true,
                  icon: ['fas', 'circle-notch'],
                  size: "lg"
                })
              ]),
              _hoisted_21
            ], 512), [
              [_vShow, _ctx.isShowLoader]
            ]),
            (_ctx.isShowClockInContent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createVNode(_component_neu_card, {
                    color: "plain-0",
                    class: "p-0 m-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_neu_table, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_neu_table_row, {
                            columns: _ctx.columnHeaders,
                            header: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.columnHeaders), (column) => {
                                return (_openBlock(), _createBlock(_component_neu_table_heading, {
                                  key: column,
                                  icon: _ctx.columnIcons[column],
                                  slot: column,
                                  style: {"padding-top":"25px !important"}
                                }, {
                                  default: _withCtx(() => [
                                    (column == 'ClockInGroup')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(column), 1)
                                        ], 64))
                                  ]),
                                  _: 2
                                }, 1032, ["icon", "slot"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["columns"]),
                          _createVNode(_component_neu_table_body, { align: "left" }, {
                            default: _withCtx(() => [
                              (_ctx.clockInDataList != null && _ctx.clockInDataList.length > 0)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.clockInDataList, (clock) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: clock }, [
                                      _createVNode(_component_neu_table_row, {
                                        class: "clockInStatusGroupRow",
                                        columns: _ctx.columnHeaders,
                                        slot: _ctx.column
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_neu_label, { slot: "ClockInGroup" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(clock.ClockedInGroupText), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["columns", "slot"]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clock.ClockInList, (dataItem) => {
                                        return (_openBlock(), _createBlock(_component_neu_table_row, {
                                          key: dataItem,
                                          columns: _ctx.columnHeaders,
                                          slot: _ctx.column
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_neu_label, {
                                              slot: "Name",
                                              title: dataItem.Name
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(dataItem.Name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["title"]),
                                            _createVNode(_component_neu_label, { slot: "Shift Start Time" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(dataItem.beginningShift), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_neu_label, { slot: "Clock-In Time" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(dataItem.actualTimeIn), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1032, ["columns", "slot"]))
                                      }), 128))
                                    ], 64))
                                  }), 128))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.isShowClockInMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}